/**
 * Track15 Audio Studio access helper (client-side UX gate).
 *
 * Parses VITE_STUDIO_ALLOWED_EMAILS (a comma-separated list of emails,
 * whitespace-tolerant, case-insensitive) and returns whether a given email
 * is allowed.
 *
 * Fails closed: if the env var is missing or empty, NO email is allowed.
 *
 * This is the CLIENT-SIDE gate (UX hint — hides the surface from non-
 * allowlisted users). The server-side gate (edge functions in Slice 2+)
 * enforces access independently via JWT-email checks against
 * STUDIO_ALLOWED_EMAILS on the Supabase Edge Function secret.
 */
export function isStudioAllowed(email: string | null | undefined): boolean {
  if (!email) return false;

  const raw = import.meta.env.VITE_STUDIO_ALLOWED_EMAILS;
  if (typeof raw !== "string" || raw.trim().length === 0) return false;

  const allowlist = raw
    .split(",")
    .map((entry) => entry.trim().toLowerCase())
    .filter((entry) => entry.length > 0);

  if (allowlist.length === 0) return false;

  return allowlist.includes(email.trim().toLowerCase());
}
